import React from 'react';
import block from 'propmods';
import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/Settings';
import { MarketDevice } from '../../model/devices';
import { DeviceLinkingCard } from '../DeviceLinkingCard/DeviceLinkingCard';
import { Expander } from '../Expander/Expander';

import './DeviceLinkingList.scss';

const b = block('DeviceLinkingList');
const t = i18n(keyset);

interface DeviceLinkingListProps {
    devices: MarketDevice[];
    afterDeviceRemove: (deviceId: string) => void;
    disabled?: boolean;
}

const DeviceLinkingListStub: React.FC = () => (
    <div {...b()}>
        <span {...b('stub')}>{t('devices-empty-list')}</span>
    </div>
);

export const DeviceLinkingList: React.FC<DeviceLinkingListProps> = ({ devices, afterDeviceRemove, disabled }) => {
    if (devices.length === 0) {
        return <DeviceLinkingListStub />;
    }

    const [publishedDevices, newDevices] = devices.reduce(
        (acc, cur) => {
            if (cur.isPublished) {
                acc[0].push(cur);
            } else {
                acc[1].push(cur);
            }

            return acc;
        },
        [[], []] as [MarketDevice[], MarketDevice[]],
    );

    const hasNewDevices = newDevices.length > 0;
    const hasPublishedDevices = publishedDevices.length > 0;

    const newDevicesTitle = hasPublishedDevices ? t('devices-new-devices') : t('devices-added-devices');

    return (
        <div {...b()}>
            {hasNewDevices && (
                <Expander title={newDevicesTitle} defaultExpanded type="default">
                    {newDevices.map((device) => {
                        const afterRemove = () => afterDeviceRemove(device.marketId);

                        return (
                            <div {...b('item')} key={device.marketId}>
                                <DeviceLinkingCard device={device} afterRemove={afterRemove} disabled={disabled} />
                            </div>
                        );
                    })}
                </Expander>
            )}
            {hasPublishedDevices && (
                <Expander title={t('devices-added-earlier')} defaultExpanded type="default">
                    {publishedDevices.map((device) => {
                        const afterRemove = () => afterDeviceRemove(device.marketId);

                        return (
                            <div {...b('item')} key={device.marketId}>
                                <DeviceLinkingCard device={device} afterRemove={afterRemove} disabled={disabled} />
                            </div>
                        );
                    })}
                </Expander>
            )}
        </div>
    );
};
